import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation9 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };


    return (

        <>
     



        <div className="container mt-1 p-3 mb-1">


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                   Certificate Course in Video Editing

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>
            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in Video Editing
                </h5>
                <p>
                    Video editing is a process of modifying or rearranging the segments of video from one or more video tapes to create a final piece of video. It also includes editing of soundtracks, video and film, Applying colour correction, filters and other enhancements and creating transitions between clips. </p>

            </div>
            <hr />



            <h5 style={{ position: "relative" }}>

                Introduction
            </h5>
            <p>This course serves as an introduction to the exciting field of security in Information technology.</p>
            <p>As our daily lives become more and more dependent on Internet-based tools and services, and as those platforms accumulate our sensitive data, the demand grows for experts in the field of security over the internet.</p>
            <hr />

            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>


            <p>After completing this course, the student will be able to perform roles with different career opportunities as shown below:</p>
            <hr />
            <h5>Career Opportunities (Industry wise)</h5>

            <ul>
                <li>Television Studio</li>
                <li>Film Studio</li>
                <li>Advertising studio</li>
                <li>Multimedia companies</li>
                <li>eLearning companies</li>
                <li>Web-Designing companies</li>
                <li>Career Paths:</li>
            </ul>
            <h4>Television & Film Editor</h4>
            <ul>
                <li>Video Editor</li>
                <li>Assistant Video Editor</li>
                <li>Film Compositor</li>
                <li>VFX Compositor</li>


            </ul>
            Hence, students get various career opportunities.
            <hr />






            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> Video Editing course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>
                <hr />
            </div>
           
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                  
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>

            <div className='p-4' >



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Introduction to Video Editing with Premiere CS4</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li> Overview of Video Editing</li>
                                <li> Uses of Premiere Pro CS4</li>
                                <li> Features of Premiere CS4</li>
                                <li> Installing Premiere Pro CS4</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Introduction to Moviemaking</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Basics of digital video and movie editing</li>
                                <li>Comparing camcorder formats</li>
                                <li>Understanding video codecs</li>
                                <li>Shooting better video</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Getting Started with Premiere Pro CS4</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li> Working with workspace</li>
                                <li> Customizing the Workspace in Premiere Pro CS4</li>
                                <li> Working with project settings</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Importing and Capturing Footage</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li> Importing files as footage</li>
                                <li>Importing stills</li>
                                <li>Importing layered Photoshop and Illustrator files</li>
                                <li>Dealing with missing media</li>
                                <li> Setting up to capture from tape</li>
                                <li> Logging Tapes</li>
                                <li> Batch-capturing footage</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">TimeLine, Sequence and Clip Management</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li> Timeline</li>
                                <li> Using Multiple Sequences</li>
                                <li>Clip Project Management</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="12">Basic Video Editing</AccordionHeader>
                        <AccordionBody accordionId="12">
                            <ul>
                                <li>Basic Editing Concept and Tools</li>
                                <li>Working with Monitor Panels</li>
                                <li>Creating Insert and Overlay Edits</li>
                                <li>Editing in the Timeline</li>
                                <li>Setting In and Out Points in the Timeline Panel</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">Editing Audio</AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li>What is Audio?</li>
                                <li>Timeline Audio Tracks</li>
                                <li>Editing Audi</li>
                                <li>Recording Audio</li>
                                <li>Gaining, Fading and Balancing</li>
                                <li>Using Audio Effects and Transitions</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Mixing and Creating Effects with the Audio Mixer</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li>Audio Mixer Overview</li>
                                <li>Setting Track Volume & Mixing Tracks</li>
                                <li>Panning & Balancing</li>
                                <li>Applying effects with Audio Mixer</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="15">Creating Transitions</AccordionHeader>
                        <AccordionBody accordionId="15">
                            <ul>
                                <li>About Video Transitions (Overview)</li>
                                <li>Applying transitions</li>
                                <li>Adjusting Transitions</li>
                                <li>Customizing Transitions</li>
                                <li>Various Transitions Effects</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="16">Creating Titles and Graphics</AccordionHeader>
                        <AccordionBody accordionId="16">
                            <ul>
                                <li>Using the Titler</li>
                                <li>Creating titles from templates</li>
                                <li>Modifying a title</li>
                                <li>Creating titles from scratch</li>
                                <li>Superimposing a title</li>
                                <li>Creating a title roll or crawl</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="17">Working with advanced editing techniques</AccordionHeader>
                        <AccordionBody accordionId="17">
                            <ul>
                                <li> Editing Utilities</li>
                                <li>Editing with tool panel tools</li>
                                <li>Fine tuning edits using the trim monitor panel</li>
                                <li>Editing a Clip Using Clip Commands</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="18">Using Video Effects</AccordionHeader>
                        <AccordionBody accordionId="18">
                            <ul>
                                <li>Exploring the Video Effects</li>
                                <li> Applying a Video Effect</li>
                                <li>Using Video Effects with Keyframes</li>
                                <li>Superimposing Video Clip Using Keying Video Effect</li>
                                <li>Applying effects using Image Matte Keying Effects</li>
                                <li>Touring Premiere Pro Video Effects</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="19">Using Color mattes and Backdrop</AccordionHeader>
                        <AccordionBody accordionId="19">
                            <ul>
                                <li>Mattes, Transparency and Opacity</li>
                                <li>Create transparency, solid colors with keys mattes</li>
                                <li>Matte other than the alpha channel</li>
                                <li>Using more mattes</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="20">Creating Motion Effects</AccordionHeader>
                        <AccordionBody accordionId="20">
                            <ul>
                                <li>Motion effect controls in Effect Controls Panel</li>
                                <li>Working with the Motion Controls</li>
                                <li>Using timeline Panel to Preview & add Keyframes</li>
                                <li>Editing Motion Paths</li>
                                <li>Adding Effects to Motion Paths</li>
                                <li>Using a clip with an Alpha Channel</li>
                                <li>Creating Traveling Mattes</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="21">Enhancing Video</AccordionHeader>
                        <AccordionBody accordionId="21">
                            <ul>
                                <li>Understanding video color</li>
                                <li>Color Correcting Basics</li>
                                <li> Start a Color Correcting Session</li>
                                <li>Using the Video Scopes</li>
                                <li>Color Enhancement Effects</li>
                                <li>Special color and luminance adjustments</li>
                                <li>Retouch Using Photoshop and After Effects</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="22">Wrapping Up and Exporting</AccordionHeader>
                        <AccordionBody accordionId="22">
                            <ul>
                                <li>Preparing to export video</li>
                                <li>Exporting to tape</li>
                                <li>Exporting to Encore DVD</li>
                                <li>Exporting to various formats using Adobe Encoder</li>
                                <li>Sharing Your Movies Online</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


            </div >
            <hr />

            <h4>Adobe Photoshop</h4>
            <p><b>Skills:</b> Importing and Capturing Footage, Timeline, Sequence and Clip Management, Basic Video Editing, Editing Audio, Mixing and Creating Effects with the Audio Mixer, Creating Transitions, Creating Titles and Graphics, Working with advanced editing techniques, Using Video Effects, Using Color mattes and Backdrops, Enhancing Video, Wrapping Up and Exporting</p>
            <p><b>Outputs:</b> Video Merging, Advertisement creation, video effects, Creating a Short Film
            </p>
            <hr />

            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation9;